// Module
var code = "<div data-control-type=\"drop-control\" class=\"ToolBarPreview\"> <label> <i class=\"fa fa-newspaper-o\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;